<template>
  <div class="help">
    <div class="contentCenter">
      <nav class="currentLocation">
        <ul class="display-flex">
          <li>
            <span>您的位置</span>
          </li>
          <li>
            <span>帮助中心</span>
          </li>
        </ul>
      </nav>
      <ul class="sidebar">
        <li
          v-for="item in sidebar"
          :key="item.id"
          :class="item.className"
          @click="handleSelectedNav(item)"
        >
          <div class="inner display-flex justify-content-space-between">
            <span>{{ item.name }}</span>
            <img src="../../assets/img/arrowLeft.png" alt />
          </div>
        </li>
      </ul>
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { postData, showLoading } from "../../assets/api/api.js";
export default {
  name: "help",

  data() {
    return {
      sidebar: [
        { id: 0, name: "常见问题", className: "active", url: "/help/helpList" },
      ],
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleSelectedNav(item) {
      this.$router.push({ path: item.url });
      this.sidebar.forEach((i) => {
        if (item.id == i.id) {
          i.className = "active";
        } else {
          i.className = "";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.help {
  .content {
    margin-bottom: 30px;
    width: 962px;
    float: right;
    background: #fff;
    padding: 0 20px;
  }
}
</style>
